import { inject, injectable } from 'inversify'
import symbols from '@/symbols'
import {
  IAppErrorFactory,
  ICompanyBase,
  IToggleFollowCompanyUseCase,
  IUseCaseOutputFactory,
  IViewerService,
  ToggleFollowCompanyUseCaseInput,
  ToggleFollowCompanyUseCaseOutput,
} from '@/types'

@injectable()
export default class ToggleFollowCompanyInteractor implements IToggleFollowCompanyUseCase {
  @inject(symbols.IViewerService) private viewerService: IViewerService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  @inject(symbols.IUseCaseOutputFactory) private outputFactory: IUseCaseOutputFactory<{
    company: null | ICompanyBase
  }>

  async handle(input: ToggleFollowCompanyUseCaseInput): Promise<ToggleFollowCompanyUseCaseOutput> {
    const output = this.outputFactory.create({
      defaultValue: {
        company: null,
      },
    })
    try {
      output.data.company = await this.viewerService.toggleFollowCompany(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }
}
